/**
 * Csv Schema of ReponsavelAssociado
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ReponsavelAssociado} from '@/model/resource/ReponsavelAssociado'

/* TODO: review generated schema */
export class CsvReponsavelAssociadoSchema extends Schema {
  readonly name = 'CsvReponsavelAssociado'

  readonly fieldSet: FieldSet<ReponsavelAssociado> = {
    idAssociadoPk: schema => schema.model.idAssociadoPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    razaoSocial: schema => schema.model.razaoSocial,
    nomeFantasia: schema => schema.model.nomeFantasia,
    cnpj: schema => Helper.cnpj(schema.model.cnpj),
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
